import { useMutation } from '@tanstack/vue-query';
import { enrichApi } from '@/shared/api';

export const useTranslateMutation = () => {
  return useMutation({
    mutationKey: ['translate-comment-mutation'],
    mutationFn: (params: enrichApi.TranslateQueryParams) =>
      enrichApi.translate(params),
  });
};
